import HttpService from "@/shared/services/http-service";
import ResultMapper from "../mappings/result-mapper";
import { IResults } from "../models/result";

export class ResultsService {
    private mapper: ResultMapper = new ResultMapper();

    public getResults(answers: string[]): Promise<any> {
        return this.doGetResultsRequest(this.getUrl(), answers);
    }

    private doGetResultsRequest(url: string, answers: string[]): Promise<any> {
        let requestBody: object = {"QuestionIds": answers};

        return new Promise((resolve, reject) => {
            HttpService.post(url, requestBody).then((result: IResults) => {
                resolve(this.mapper.mapResults(result.studies));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getUrl(): string {
        return `${window.location.pathname}/results`;
    }
}